<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"

    :headers="headers"
    item-key="_id"
  >
    <template v-slot:item.strike="{ item }">
      {{ formatCurrency(item.strike) }}
    </template>

    <template v-slot:item.expirationDate="{ item }">
      {{ formatDate(item.expirationDate) }}
    </template>

    <template v-slot:item.quantity="{ item }">
      <span :class="{ 'error--text': item.quantity < 0 }">
        {{ formatNumber(item.quantity) }}
      </span>
    </template>

    <template v-slot:item.refPrice="{ item }">
      {{ formatCurrency(item.refPrice) }}
    </template>

    <template v-slot:item.totalDeltaExposure="{ item }">
      <span :class="{ 'error--text': item.totalDeltaExposure < 0 }">
        {{ formatCurrency(item.totalDeltaExposure) }}
      </span>
    </template>

    <template v-slot:item.value="{ item }">
      <span :class="{ 'error--text': item.value < 0 }">
        {{ formatCurrency(item.value) }}
      </span>
    </template>

    <template v-slot:item.percValue="{ item }">
      <span :class="{ 'error--text': item.percValue < 0 }">
        {{ formatPercentage(item.percValue) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import {
  formatCurrency,
  formatDate,
  formatNumber,
  formatPercentage,
} from '@/utils/format-utils';

export default {
  name: 'HoldingFutureOptionsTable',

  inheritAttrs: false,

  data: () => ({
    headers: [
      {
        value: '_id',
        text: '_id',
      },

      {
        value: 'ticker',
        text: 'Ativo',
      },

      {
        value: 'book',
        text: 'Book',
      },

      {
        value: 'strike',
        text: 'Preço de strike',
        align: 'end',
      },

      {
        value: 'expirationDate',
        text: 'Vencimento',
      },

      {
        value: 'quantity',
        text: 'Quantidade',
        align: 'end',
      },

      {
        value: 'refPrice',
        text: 'PU de mercado',
        align: 'end',
      },

      {
        value: 'totalDeltaExposure',
        text: 'Exposição',
        align: 'end',
      },

      {
        value: 'value',
        text: 'Valor de Mercado',
        align: 'end',
      },

      {
        value: 'percValue',
        text: '%PL',
        align: 'end',
      },
    ],
  }),

  methods: {
    formatCurrency,
    formatDate,
    formatNumber,
    formatPercentage,
    formatPerformance: (val) => formatPercentage(val, {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    }),
  },
};
</script>
